// 한국어 (기본/fallback). 파일럿: 로그인 / 사이드바 / 설정 / 방송관리.
//  ⚠ 펫이름·닉네임·채팅 등 DB/사용자 입력 값은 번역 대상 아님.
export default {
  common: {
    save: "저장",
    cancel: "취소",
    close: "닫기",
    comingSoon: "준비중입니다",
  },
  brand: { name: "버츄펫", title: "버츄펫 스튜디오" },
  auth: {
    loginRequired: "로그인 정보가 없습니다. 로그인화면으로 돌아갑니다",
  },
  login: {
    tabStreamer: "스트리머",
    tabFan: "팬",
    fanWelcome: "팬으로 참여 🎉",
    fanSubtitle: "좋아하는 스트리머의 펫에 보낼 리액션을 만들어요.",
    fanComingSoon: "팬 로그인은 곧 열립니다.",
    welcome: "환영합니다 🌈",
    subtitle: "귀여운 친구들이 당신을 기다리고 있어요, 로그인해주세요 🐶",
    discord: "Discord로 로그인",
    email: "이메일로 로그인",
    submit: "로그인",
    errExpired: "만료된 계정입니다. 관리자에게 문의하세요",
    errNotFound: "이메일 또는 비밀번호가 올바르지 않습니다",
    errUnknown: "알려지지 않은 오류가 발생했습니다",
    errDiscord: "디스코드 로그인에 실패했습니다",
  },
  nav: {
    home: "집",
    broadcastSection: "방송",
    broadcastManage: "플랫폼 연결",
    broadcast: "방송하기",
    broadcastGame: "방송게임",
    petSetting: "펫설정",
    prepare: "MOD",
    makeReaction: "리액션 만들기",
    upload: "음악·자막 업로드",
    myVirtupet: "내 버츄펫",
    myItems: "보유 아이템",
    training: "훈련하기",
    motion: "리액션",
    viewerAffinity: "시청자 친밀도",
    world: "버츄펫 월드",
    petStore: "펫스토어",
    hospital: "병원",
    ranking: "랭킹",
    gather: "당근베팅",
    sns: "소셜",
    socialBroadcast: "방송 캔버스",
    shortForm: "숏폼",
    lifeFourCut: "인생네컷",
    settings: "설정",
    logout: "Log out",
    petSelect: "펫 선택",
    currencyStore: "🥕 구매하기",
    expand: "펼치기",
    collapse: "접기",
    themeLight: "라이트 모드로",
    themeDark: "다크 모드로",
    language: "언어",
    languageTitle: "언어 설정",
    country: "국가",
    countryTitle: "국가 설정",
    countrySearch: "국가 검색",
    logoutConfirmTitle: "로그아웃",
    logoutConfirmBody: "정말 로그아웃 하시겠어요?",
  },
  care: {
    feed: "밥주기",
    play: "놀아주기",
    clean: "씻기기",
    hunger: "배고픔",
    energy: "에너지",
    awake: "졸림",
    close: "닫기",
  },
  // 동물 id별 표시명 (펫 카탈로그). MODEL_CATALOG의 한글명과 동기 유지.
  animals: {
    sloth: "나무늘보",
    cow: "젖소",
    bull: "황소",
    moose: "무스",
    monkey: "원숭이",
    bulldog: "불독",
    cat: "고양이",
    bear: "곰",
    deer: "사슴",
    dog: "강아지",
    dog2: "강아지2",
    donkey: "당나귀",
    elephant: "코끼리",
    fox: "여우",
    hippo: "하마",
    horse: "말",
    koala: "코알라",
    lion: "사자",
    rhino: "코뿔소",
    panda: "판다",
    pig: "돼지",
    rabbit: "토끼",
    raccoon: "너구리",
    sheep: "양",
    squirrel: "다람쥐",
    tiger: "호랑이",
    unicorn: "유니콘",
    zebra: "얼룩말",
  },
  fourcut: {
    title: "인생네컷",
    subtitle: "현재 펫의 랜덤 모션을 4컷으로 찍어보세요.",
    shoot: "촬영하기",
    reshoot: "다시 촬영",
    download: "PNG 저장",
    shootHint: "촬영하기를 눌러요",
    rerollTip: "각 컷을 클릭하면 그 컷만 다시 찍어요.",
    pattern_solid: "단색",
    pattern_gradient: "그라데이션",
    pattern_dots: "도트",
    pattern_stripes: "스트라이프",
  },
  settings: {
    title: "설정",
    tabAccount: "계정설정",
    tabBroadcast: "방송설정",
    nickname: "닉네임",
    profile: "프로필 사진",
    profileEdit: "프로필 사진 변경",
    profileTabUrl: "URL 입력",
    profileTabUpload: "업로드",
    profileUrlHint: "https:// 로 시작하는 외부 이미지 주소",
    profileUrlInvalid: "https:// 로 시작하는 URL을 입력해주세요.",
    profileUploadHint: "이미지를 자동으로 작게 리사이즈해 업로드합니다.",
    cropHint: "원 안에 들어갈 부분을 드래그·확대해 맞춰주세요.",
    profileSaved: "프로필 사진이 변경되었습니다.",
    profileFailed: "프로필 사진 변경에 실패했습니다.",
    passwordChange: "비밀번호 변경",
    newPassword: "새 비밀번호 (6자 이상)",
    confirmPassword: "새 비밀번호 확인",
    change: "변경",
    language: "언어",
    screenPosition: "방송화면 설정 (위치)",
    screenScale: "방송화면 설정 (크기)",
    nicknameSaved: "닉네임이 변경되었습니다.",
    nicknameFailed: "닉네임 변경에 실패했습니다.",
    pwTooShort: "비밀번호는 6자 이상이어야 합니다.",
    pwMismatch: "비밀번호 확인이 일치하지 않습니다.",
    pwChanged: "비밀번호가 변경되었습니다.",
    pwFailed: "비밀번호 변경에 실패했습니다.",
  },
  categoryHub: {
    subtitle: "원하는 메뉴를 선택하세요.",
    // 임시 설명 (추후 수정)
    desc: {
      petStore: "악세사리·음식 등 아이템을 구매해요",
      hospital: "펫 컨디션을 검사하고 치료해요",
      ranking: "다른 펫들과 레벨을 겨뤄봐요",
      gather: "🥕를 모으고 구매해요",
      myItems: "보유한 아이템을 확인해요",
      petSelect: "함께 방송할 펫을 선택해요",
      petSetting: "펫 이름·배경 등을 설정해요",
      training: "펫에게 반응을 가르쳐요",
      motion: "펫의 리액션을 골라 재생해요",
      viewerAffinity: "시청자와의 친밀도를 확인해요",
      broadcast: "OBS 링크 발급·실시간으로 방송을 제어해요",
      broadcastGame: "시청자와 함께하는 미니게임을 즐겨요",
      broadcastManage: "치지직·트위치 등 플랫폼을 연동해요",
      socialBroadcast: "배경을 꾸미고 펫을 자유롭게 배치해요",
      shortForm: "펫으로 숏폼 영상을 만들어요",
      lifeFourCut: "현재 펫의 인생네컷을 찍어요",
      makeReaction: "채팅·후원에 반응하는 리액션을 만들어요",
      upload: "방송에 쓸 음악·자막을 업로드해요",
    },
  },
  broadcastGame: {
    title: "방송게임",
    subtitle: "시청자가 참여하는 미니게임으로 방송을 즐겁게 만들어요.",
    wordGuessName: "제시어 맞추기",
    wordGuessDesc: "시청자가 채팅으로 제시어를 맞춰요",
    play: "시작하기",
  },
  broadcastManage: {
    title: "플랫폼 연결",
    subtitle: "방송 플랫폼을 연동하면 채팅/후원/구독을 받아 펫이 반응합니다.",
    tabChzzk: "치지직",
    tabTwitch: "트위치",
    tabSoop: "숲",
    tabYoutube: "유튜브",
    tabInstagram: "인스타 라이브",
    tabChzzkRelay: "치지직(릴레이)",
    chzzkTitle: "치지직 계정 연동",
    chzzkDesc: "네이버 계정으로 치지직을 연동하면 공식 API로 채팅/후원/구독을 받아옵니다.",
    connected: "연동됨",
    notConnected: "미연동",
    useInBroadcast: "활성화",
    chzzkConnect: "치지직으로 연동",
    disconnect: "연동 해제",
    connectShort: "연동",
    changeShort: "변경",
    disconnectShort: "해제",
    twitchTitle: "트위치 채널 연동",
    twitchDesc: "트위치 채널명을 입력하면 익명으로 채팅을 받아옵니다. (별도 로그인 불필요)",
    twitchPlaceholder: "트위치 채널명 (예: ninja)",
    twitchConnect: "트위치 연동",
    twitchChange: "채널 변경",
    soopTitle: "숲 연동",
    youtubeTitle: "유튜브 연동",
    instagramTitle: "인스타 라이브 연동",
    channelChecking: "채널 정보 확인 중",
    confirmDisconnectChzzk: "치지직 연동을 해제할까요?",
    confirmDisconnectTwitch: "트위치 연동을 해제할까요?",
    chzzkConnected: "치지직 계정이 연동되었습니다.",
    chzzkConnectFailed: "치지직 연동을 시작할 수 없습니다.",
    chzzkDisconnected: "치지직 연동이 해제되었습니다.",
    twitchConnected: "트위치 채널이 연동되었습니다.",
    twitchConnectFailed: "트위치 연동에 실패했습니다.",
    twitchDisconnected: "트위치 연동이 해제되었습니다.",
    disconnectFailed: "연동 해제에 실패했습니다.",
    settingChangeFailed: "설정 변경에 실패했습니다.",
    callbackConnected: "치지직 계정이 연동되었습니다.",
    callbackExpired: "연동 요청이 만료되었습니다. 다시 시도해주세요.",
    callbackError: "치지직 연동에 실패했습니다.",
    relayTitle: "치지직 릴레이 (관리자)",
    relayDesc: "다른 스트리머의 채널명을 입력하면 시청자로 입장해 공개 채팅을 받아옵니다. (방송 중인 채널만)",
    relayPlaceholder: "대상 치지직 채널명",
    relayConnect: "릴레이 연결",
    relayChange: "채널 변경",
    relayConnected: "릴레이 대상 채널이 설정되었습니다.",
    relayConnectFailed: "릴레이 채널 설정에 실패했습니다.",
    relayNotFound: "해당 이름의 치지직 채널을 찾을 수 없습니다.",
    relayDisconnected: "릴레이 연결이 해제되었습니다.",
    confirmDisconnectRelay: "릴레이 연결을 해제할까요?",
  },
  onboarding: {
    welcome: "환영합니다 🌈",
    nicknamePrompt: "버츄펫에서 사용할 닉네임을 정해주세요.",
    nickname: "닉네임",
    agreeTerms: "이용약관 및 개인정보 처리방침에 동의합니다",
    next: "다음",
    nicknameSaveError: "닉네임 저장 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
    metaTitleSuffix: "의 정보를 입력해주세요 ✍️",
    name: "이름",
    age: "나이",
    gender: "성별",
    job: "직업",
    planet: "행성",
    start: "시작하기",
    required: "필수 항목입니다",
    agePositive: "1 이상의 숫자",
    gachaTitlePrefix: "운명의 ",
    gachaTitleSuffix: "을 뽑아보세요 🎰",
    draw: "뽑기",
    reroll: "다시 뽑기",
    startWithThis: "이 친구로 시작 →",
    viewAll: "전체보기",
    lowBalance: "🥕가 부족해 다시 뽑기는 어려워요. 지금 친구로 시작할 수 있어요!",
    catalogTitle: "버츄펫 도감",
    petCreateError: "펫 생성 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
  },
  pricing: {
    title: "가격 안내",
    subtitle:
      "버츄펫은 방송 오버레이용 가상 펫 서비스입니다. 아래는 인앱 재화 당근(🥕) 구매 가격입니다. 당근은 서비스 내 펫 성장·아이템 등에 사용되는 디지털 재화입니다.",
    disclaimer:
      "당근은 Virtupet 소프트웨어 안에서만 사용되는 소모성 인앱 아이템입니다. 현금으로 환급되거나 스트리머 등 제3자에게 지급되지 않으며, 후원·기부 기능이 아닙니다.",
    carrots: "{n} 당근",
    bonus: "+{n} 보너스",
    taxIncluded: "세금 포함",
    note1: "표시 가격은 세금 포함 금액이며, 최종 결제 금액·통화·현지 세금은 결제 단계에서 확정됩니다.",
    note2: "당근은 디지털 재화(소모성 인앱 아이템)로, 구매 후 계정에 적립됩니다.",
    note3: "결제 통화는 표시 언어/지역에 따라 달라집니다 (한국어=₩ / English=$ / 日本語=¥).",
    contact: "결제·환불 문의:",
  },
  footer: {
    rights: "All rights reserved.",
    contact: "문의",
    terms: "이용약관",
    privacy: "개인정보",
    refunds: "환불 정책",
  },
};
